import { createAsyncThunk } from '@reduxjs/toolkit';
import { postCreateAndUpdateProjectAssignments } from 'store/assignments/services/postCreateAndUpdateProjectAssignments.service';

/**
 * Saves the Litterabudjetti edits (budget maps, comments, completion,
 * alternative name) of the given project. Sends only the given update items;
 * the endpoint SETs every key it receives and REMOVEs keys sent as null,
 * then returns ALL_NEW items which the slices store with setMany.
 * @param {{projectId: string, assignmentsToUpdate: Array<object>}} arg
 * @returns {Promise<Array<object>>} the updated assignment items
 */
export const saveAssignmentBudgets = createAsyncThunk(
  'expenseTracking/saveAssignmentBudgets',
  async ({ projectId, assignmentsToUpdate }) => {
    if (!assignmentsToUpdate || assignmentsToUpdate.length === 0) return [];
    return postCreateAndUpdateProjectAssignments(
      projectId,
      [],
      assignmentsToUpdate
    );
  }
);
